import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import styled, { css } from 'styled-components/macro';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { ACCESS } from 'config';
import query from 'query-string';
import {
    Container,
    Grid,
    Column,
    LoginForm,
    SignupForm,
    RecoverPasswordForm,
    Features,
    Pictorials,
    Section,
    Typography,
} from 'components';
import * as help from 'helpers';
import { sendSignupPageView } from 'tracking/sendTrackingEvent';

const FORMS = {
    login: 'login',
    signup: 'signup',
    password: 'password',
};

const BenefitsColumn = styled((props) => <Column {...props} />)`
    ${({ theme }) => help.media.toTablet`
        margin-top: ${theme.space.large};
        order: 2;
    `}
`;

const Header = styled((props) => <Typography {...props} />)`
    ${help.media.toTablet`
        display: none;
    `}
`;

const MobileTitle = styled((props) => <Typography {...props} />)`
    display: none;
    ${help.media.toTablet`
        display: block;
    `}
`;

const Div = styled.div`
    ${({ $showBenefits, theme }) =>
        !$showBenefits &&
        css`
            text-align: center;
            margin-bottom: ${theme.space.large};
        `}
`;

const Page = ({ history, location }) => {
    const search = query.parse(location.search);
    const hasCampaign = ACCESS[search.campaign];
    const campaign =
        search.campaign && hasCampaign
            ? ACCESS[search.campaign]
            : ACCESS.default;
    const { defaultForm, showBenefits } = campaign;

    const [form, setForm] = useState(defaultForm);
    const [title, setTitle] = useState(campaign[defaultForm]);

    const destination = help.route_continue_with_params();

    help.useEffectOnlyOnce(() => {
        sendSignupPageView();
    });

    const showLoginForm = (e) => {
        e && e.preventDefault();

        setForm(FORMS.login);
        setTitle(campaign.login);
    };

    const showPasswordForm = (e) => {
        e && e.preventDefault();

        setForm(FORMS.password);
    };

    const showSigupForm = (e) => {
        e && e.preventDefault();

        setForm(FORMS.signup);
        setTitle(campaign.signup);
    };

    return (
        <React.Fragment>
            <Section topMargin minHeight="100vh" overlay="light">
                <Container>
                    <Grid alignCenter>
                        {form !== FORMS.password && (
                            <BenefitsColumn
                                cols={showBenefits ? 6 : 12}
                                tablet={12}
                            >
                                <Div $showBenefits={showBenefits}>
                                    <Header variant="h2">
                                        {i18n._(title)}
                                    </Header>
                                </Div>

                                {showBenefits && (
                                    <Features
                                        pictorialColor="brand"
                                        orientation="vertical"
                                        features={[
                                            {
                                                icon: Pictorials.Play,
                                                name: i18n._(
                                                    t`Your personal music teacher`,
                                                ),

                                                description: i18n._(
                                                    t`Curriculum designed by experts and technology that gives instant feedback.`,
                                                ),
                                            },
                                            {
                                                icon: Pictorials.Songs,
                                                name: i18n._(
                                                    t`Play the music you love`,
                                                ),

                                                description: i18n._(
                                                    t`Enjoy thousands of popular songs, lessons and exercises.`,
                                                ),
                                            },
                                            {
                                                icon: Pictorials.Guitars,
                                                name: i18n._(
                                                    t`One Membership.<br />Endless possibilities.`,
                                                ),

                                                description: i18n._(
                                                    t`Learn guitar, piano, bass guitar, ukulele or singing.`,
                                                ),
                                            },
                                        ]}
                                    />
                                )}
                            </BenefitsColumn>
                        )}

                        <Column cols={6} tablet={12} desktop={5}>
                            <MobileTitle
                                variant="h2"
                                spaceBottom="large"
                                align="center"
                            >
                                {i18n._(title)}
                            </MobileTitle>

                            {form === FORMS.login && (
                                <LoginForm
                                    history={history}
                                    onLoginDestination={destination || null}
                                    onSignupClick={showSigupForm}
                                    onForgotPasswordClick={showPasswordForm}
                                />
                            )}

                            {form === FORMS.signup && (
                                <SignupForm
                                    onSignupDestination={destination || null}
                                    onLoginClick={showLoginForm}
                                />
                            )}

                            {form === FORMS.password && <RecoverPasswordForm />}
                        </Column>
                    </Grid>
                </Container>
            </Section>
        </React.Fragment>
    );
};

export default withRouter(observer(Page));
